import { graphql } from '@/gql'

export const GetHire = graphql(`
  query GetHireForContractDetails($id: ID!) {
    hire(id: $id) {
      ...ContractDetailsHireFields
    }
  }
`)
